/** Immutable list helpers used by every list editor. */
export const listOps = {
  set: <T>(xs: T[], i: number, v: T) => xs.map((x, j) => (j === i ? v : x)),
  remove: <T>(xs: T[], i: number) => xs.filter((_, j) => j !== i),
  move: <T>(xs: T[], from: number, to: number) => {
    if (to < 0 || to >= xs.length || from < 0 || from >= xs.length) return xs;
    const next = [...xs];
    const [x] = next.splice(from, 1);
    next.splice(to, 0, x as T);
    return next;
  },
};
